function addStyles (win, styles) {
  styles.forEach(style => {
    let link = win.document.createElement('link')
    link.setAttribute('rel', 'stylesheet')
    link.setAttribute('type', 'text/css')
    link.setAttribute('href', style)
    // link.setAttribute('media', 'print')
    win.document.getElementsByTagName('head')[0].appendChild(link)
  })
}

const VueHtmlToPaper = {
  install (Vue, options) {
    Vue.mixin({
      methods: {
        $htmlToPaper (el, opts = options) {
          let {
            name,
            specs,
            replace,
            styles
          } = opts
          specs = specs.length ? specs.join(',') : ''

          const element = document.getElementById(el)

          if (!element) {
            alert(`Element to print #${el} not found!`)
            return
          }

          const url = ''
          const win = window.open(url, name, specs, replace)

          win.document.write(`
            <html>
              <head>
                <title>${document.title}</title>
              </head>
              <body>
                ${element.innerHTML}
              </body>
              <style>
                @media print {
                  @page {
                    size: 5.5in 11.in; /* landscape */
                    /* you can also specify margins here: */
                    margin-left: 10mm;
                    margin-right: 10mm; /* for compatibility with both A4 and Letter */

                  }
                  .fullwidth { width: 99%; }
                  .mdl-grid{
                    margin: 8px;
                    -webkit-print-color-adjust:exact;
                  }
                  #title{
                    text-align: left;
                    height: 200px;
                    width:200px;
                  }
                  .center-items {
                    justify-content: center;
                  }
                  .mdl-data-table{
                    white-space:nowrap
                  }
                  .mdl-data-table td{
                    padding: 8px 8px;
                  }
                  .mdl-data-table tbody tr{
                    height: 30px;
                  }
                  .mdl-data-table tbody td{
                    height: 30px;
                  }
                  .mdl-data-table tbody tr:last-of-type{
                    border-bottom:4px double rgba(0,0,0,.12);
                  }
                  .mdl-data-table thead{
                    display: contents
                  }
                  .mdl-data-table td:last-of-type, .mdl-data-table th:last-of-type{
                    border-right: 2px solid rgba(0,0,0,.12)
                  }
                  img{
                      display: block;
                      margin: auto;
                  }
                }
                .fullwidth { width: 99%; }
                .mdl-grid{
                  margin: 8px;
                  -webkit-print-color-adjust:exact;
                }
                #title{
                  text-align: left;
                  height: 200px;
                  width:200px;
                }
                .center-items {
                  justify-content: center;
                }
                .mdl-data-table{
                  white-space:nowrap
                }
                .mdl-data-table td{
                  padding: 8px 8px;
                }
                .mdl-data-table tbody tr{
                  height: 30px;
                }
                .mdl-data-table tbody td{
                  height: 30px;
                }
                .mdl-data-table tbody tr:last-of-type{
                  border-bottom:4px double rgba(0,0,0,.12);
                }
                .mdl-data-table td:last-of-type, .mdl-data-table th:last-of-type{
                  border-right: 2px solid rgba(0,0,0,.12)
                }
              </style>
            </html>
          `)

          addStyles(win, styles)

          setTimeout(() => {
            // win.document.close()
            win.focus()
            win.print()
            // win.close()
          }, 1000)
          return true
        }
      }
    })
  }
}

export default VueHtmlToPaper



// WEBPACK FOOTER //
// ./src/components/printer.js